import React, { useRef } from 'react';
import Box from '../common/Box';
import ModuleBox from './ModuleBox';
import { toPercentTime } from '../../../common/utils/convertUtil';
import Link from 'next/link';

export default function SliderItem (props) {
  // srs_div: "03",
  // srs_no: 0,
  // srs_dtl_no: 0,
  // relateId={relateId}
  // relateTitle={relateTitle}
  // relateTitleViewYn={relateTitleViewYn}
  // relateType={relateType}

  const ref = useRef(null);
  const childRef = useRef(null);
  const onHover = (e) => {
  };

  const onHoverLeave = (e) => {
  };

  function moveSlide (val) {
    props.moveSlide(val);
  }

  switch (props.type) {
    case 'poster':
      break;
    case 'event':
      break;
    case 'modulebox':
      break;
    case 'schedule':
      break;
    case 'eventtopbox':
      break;
    default:
      break;
  }

  const moduleBoxIndex = props.slide_key;
  // const link = props.data.link ;
  // console.log('find data : ' + props.home_link);

  if (props.type === 'modulebox') {
    return (

      <li
        // key={moduleBoxIndex}
        className={`mvsl_inner${props.index === props.currentIndex ? ' current' : ''}`}
        style={{ background: `linear-gradient(to right, ${props.img_bg_color_left} 50%, ${props.img_bg_color_right} 50%)` }}
      >
        <a href={props.home_link + '?div=main_top_img' || ''} className='mvsl_link_home' title='홈페이지 바로가기' />
        <ModuleBox {...props} imageQuality={props.imageQuality || 75} moveSlide={moveSlide} />
      </li>
    );
  } else if (props.type === 'eventtopbox') {
    // img={props.data.img || props.data.pc_img_url || props.data.pgm_img_url}
    // console.log('find data : ' + props.img_url);
    if (props.link_url !== null) {
      let linkUrl;
      if (props.link_url) {
        const temp = new URL(props.link_url);
        temp.searchParams.set('div', 'event_top');
        linkUrl = temp.toString();
      }
      return (
        <li className={`event_topswipe_inner${props.index === props.currentIndex ? ' current' : ''}`}>
          <Link href={`${linkUrl}`}>
            <a target={(props.link_new_yn === 'Y' ? '_blank' : '')} className='event_topswipe_link'>
              <img src={props.img_url} className='event_topswipe_image' />
            </a>
          </Link>
        </li>
      );
    } else {
      return (
        <li className={`event_topswipe_inner${props.index === props.currentIndex ? ' current' : ''}`}>
          <img src={props.img_url} className='event_topswipe_image' />
        </li>
      );
    }
  } else {
    const listClassName = (props.type === 'event' || typeof props.type === 'number') ? 'module_thumb_list_cont' : `module_${props.type}_list_cont`;

    let currentValue;
    if (props.data.current !== undefined && props.data.current) {
      currentValue = true;
    } else {
      currentValue = !!((props.index !== undefined && props.index === props.currentIndex));
    }

    const label = [];
    if (props.data.channel_payment === 'N') label.push({ type: 'free' });
    if (parseInt(props.data.target_age) >= 19) label.push({ type: '19' });
    if (props.data.channelid === 'S17' || props.data.channelid === 'S18') label.push({ type: 'bora' });

    const percent = toPercentTime(props.data.starttime, props.data.endtime);
    const progress = {
      percent: percent,
      status: `${props.data.starttime}~${props.data.endtime} ${percent} 방송 중..`
    };

    return (
      <li
        key={props.data.ord_no}
        ref={ref}
        onMouseLeave={(e) => onHoverLeave(e)}
        onMouseEnter={(e) => onHover(e)}
        className={listClassName}
      >

        <Box
          link_new_yn={props.data.link_new_yn}
          relateId={props.relateId}
          relateTitle={props.relateTitle}
          relateTitleViewYn={props.relateTitleViewYn}
          relateType={props.relateType}
          content_date={props.data.content_date}
          content_num={props.data.content_num}
          content={props.data.content}
          srs_div={props.data.srs_div}
          srs_no={props.data.srs_no}
          srs_dtl_no={props.data.srs_dtl_no}
          view={props.view}
          type={props.type}
          current={currentValue}
          label={label}
          time={props.data.time || ''}
          play={props.data.play || false}
          img={props.data.img || props.data.pc_img_url || props.data.pgm_img_url || props.data.img_url}
          progress={progress}
          imageQuality={props.imageQuality || 75}
          link={props.data.link || props.data.link_url || props.data.homepage_url || props.data.pc_img_link}
          title={props.data.pc_title}
          info={{
            title: (props.data.program_title || props.data.title),
            desc: (props.data.desc || props.data.pc_title || (props.data.starttime != null ? `${props.data.starttime} ~ ${props.data.endtime}` : '')),
            pgm_title: (props.data.pgm_title),
            pgm_tms_title: (props.data.pgm_tms_title)
          }} // TODO childmild ======>
          targetage={props.data.targetage}
          mainContentsType={props.mainContentsType}
          data={props.data}
          bottom_type={props.bottom_type}
          clickParams={props.clickParams}
          pc_view_yn={props.data.pc_view_yn}
        />
      </li>
    );
  }
}
